<template>
  <div id="carrusel" class="carousel slide" data-bs-ride="carousel">
    <!-- Indicadores -->
    <div class="carousel-indicators">
      <button
        v-for="(item, index) in items"
        :key="'indicator-' + index"
        type="button"
        data-bs-target="#carrusel"
        :data-bs-slide-to="index"
        :class="{ active: index === 0 }"
        :aria-current="index === 0 ? 'true' : undefined"
        :aria-label="`Slide ${index + 1}`"
      ></button>
    </div>

    <!-- Slides -->
    <div class="carousel-inner">
      <div
        v-for="(item, index) in items"
        :key="'slide-' + index"
        :class="['carousel-item', { active: index === 0 }]"
      >
        <img :src="item.image" class="d-block w-100" :alt="item.content[selectedLang]?.title || ''" />
        <div class="carousel-caption d-block d-md-flex flex-column">
          <h3 class="carousel-title">{{ item.content[selectedLang]?.title || '' }}</h3>
          <p class="carousel-text">{{ item.content[selectedLang]?.text || '' }}</p>
          <router-link :to="item.link" class="saber-mas-btn" @click="goToServicio()">
            {{ item.content[selectedLang]?.button || '' }}
          </router-link>
        </div>
      </div>
    </div>

    <!-- Controles -->
    <button class="carousel-control-prev" type="button" data-bs-target="#carrusel" data-bs-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Anterior</span>
    </button>
    <button class="carousel-control-next" type="button" data-bs-target="#carrusel" data-bs-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="visually-hidden">Siguiente</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'AppCarrusel',
  props: {
    items: {
      type: Array,
      required: true
    },
    selectedLang: {
      type: String,
      required: true
    }
  },
  methods: {
    goToServicio() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
};
</script>

<style scoped>
.carousel-caption {
  height: 300px;
  width: 30%;
  flex-direction: column;
}

.carousel-title {
  font-size: 30px;
  text-align: justify;
  color: black;
}

.carousel-text {
  text-align: justify;
  color: black;
}

.saber-mas-btn {
  text-align: center !important;
  display: inline-block;
  background-color: black;
  color: white;
  padding: 0.4rem 1.2rem;
  border-radius: 999px;
  font-family: 'Caveat-Bold', cursive;
  text-decoration: none;
  font-size: 1.1rem;
  margin-top: 0.5rem;
  width: 200px;
  transition: background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease;
}

.saber-mas-btn:hover {
  background-color: #2c74b8;
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  color: #ffffff;
}

/* Indicadores personalizados */
.carousel-indicators [data-bs-target] {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: black;
  border: 1px solid transparent;
  margin: 0 4px;
}

.carousel-indicators .active {
  background-color: transparent;
  border: 2px solid black;
}

.carousel-indicators button {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: none;
  background-color: #aaa;
  margin: 0 4px;
  transition: background-color 0.3s ease, transform 0.3s ease;
}

.carousel-indicators button:hover {
  background-color: #333;
  transform: scale(1.3);
  cursor: pointer;
}

.carousel-indicators button.active {
  background-color: #000;
}

.carousel-control-prev,
.carousel-control-next {
  width: 5%;
  transition: transform 0.3s ease, filter 0.3s ease;
  z-index: 1 !important;
}

.carousel-control-prev:hover,
.carousel-control-next:hover {
  transform: scale(1.2);
  filter: brightness(1.5);
  cursor: pointer;
}

.d-block.w-100 {
  transition: transform 0.4s ease, box-shadow 0.4s ease;
}

.d-block.w-100:hover {
  transform: scale(1.05);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.3);
  cursor: pointer;
}

/* Ajustes para móviles */
@media (max-width: 767.98px) {
  .carousel-caption {
    position: static;
    height: auto;
    width: 100%;
    background: rgba(255,255,255,0.7);
    padding: 1rem;
    text-align: justify;
  }
  .carousel-title,
  .carousel-text {
    text-align: justify;
    color: #000;
  }
}
</style>
